import { action, computed, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { MembershipTokenIndexView } from '../../../../types/membershipTokens';
import { MembershipTokenApis } from '../../../../apis/membershipTokens';
import { createSummaries, MembershipSummary } from '../../../../types/membershipSummaries';
import { DialogState } from '../../../../../commonv3/states/dialogState';
import { MembershipItemId } from '../../../../../commonv3/types/membershipPlans';
import { MembershipUpdateRequestApis, OperationType } from '../../../../apis/membershipUpdateRequests';
import { SubmitState } from '../../../../../commonv3/states/SubmitState';
import { translateErrorMessage } from '../../../../../commonv3/api/protocol';
import { SubscriptionsApis } from '../../../../apis/subscriptions';
import { SubscriptionSummary } from '../../../../types/subscriptionSummary';
import { SubscriptionSummariesApis } from '../../../../apis/subscriptionSummaries';

export class PlanPaneState2 {
    @observable tokens: RemoteResourceV3<MembershipTokenIndexView[]> = RemoteResourceV3.loading();
    @observable cancelUpdateDialog = new DialogState();
    @observable cancelRequest = null;
    @observable submitState = new SubmitState();
    @observable subscriptionSummaries: RemoteResourceV3<SubscriptionSummary[]> = RemoteResourceV3.loading();

    @action.bound
    async init() {
        await this.loadTokens();
        await this.reloadSubscriptionSummaries();
    }

    @computed
    get loading() {
        return this.tokens.loading || this.subscriptionSummaries.loading;
    }

    @action.bound
    async loadTokens() {
        await updateRemoteResourceV3(this.tokens, (v) => (this.tokens = v), () => MembershipTokenApis.findAll());
    }

    async reloadSubscriptionSummaries() {
        await updateRemoteResourceV3(
            this.subscriptionSummaries,
            (v) => (this.subscriptionSummaries = v),
            () => SubscriptionSummariesApis.findAll()
        );
    }

    @computed
    get membershipTokens(): MembershipTokenIndexView[] {
        return this.tokens.getOrElse([]);
    }

    @computed
    get membershipSummaries(): MembershipSummary[] {
        return createSummaries(this.tokens.getOrElse([]));
    }

    @computed
    get hasSubscription(): boolean {
        return this.membershipTokens.some((token) => token.subscribed);
    }

    @action.bound
    requestCancelUpdate(currentItemId: MembershipItemId, nextItemId: MembershipItemId) {
        this.cancelRequest = {
            currentItemId,
            nextItemId,
        };
        this.cancelUpdateDialog.open();
    }

    @action.bound
    async cancelUpdate() {
        await this.submitState.operate(async () => {
            try {
                await MembershipUpdateRequestApis.create(
                    this.cancelRequest.nextItemId,
                    this.cancelRequest.currentItemId,
                    OperationType.CANCEL
                );
                await this.init();
                this.cancelUpdateDialog.close();
            } catch (e) {
                alert('キャンセルに失敗しました: ' + translateErrorMessage(e));
            }
        });
    }

    @action.bound
    async cancelSuspension(subscriptionCode: string, subscriptionSuspensionCode: string) {
        try {
            await this.submitState.operate(async () => {
                SubscriptionsApis.cancel_suspend(subscriptionCode, subscriptionSuspensionCode);
            });
            await this.init();
        } catch (e) {
            alert('休会予約のキャンセルに失敗しました: ' + translateErrorMessage(e));
        }
    }
}
